const getRemainedDays = (expires) => {
    const today = new Date()
    expires = new Date(expires)
    const diff = expires - today

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))

    return days
}

exports.filterBotPermissions = (bot, selectedPerms, oldPerms, permissions) => {
    let remainedDays = getRemainedDays(bot.expires)
    if (remainedDays < 0) remainedDays = 0

    let price = 0
    for (let p of permissions) {
        if (p.name === "createBot") continue
        if (!oldPerms[p.name]?.checked && selectedPerms[p.name]?.checked) {
            if (p.multi) {
                price += ((p.price * selectedPerms[p.name].multi) / 30) * remainedDays
            } else {
                price += (p.price / 30) * remainedDays
            }
        } else if (p.multi && oldPerms[p.name] && selectedPerms[p.name]) {
            if (oldPerms[p.name].multi < selectedPerms[p.name].multi) {
                price += ((p.price * (selectedPerms[p.name].multi - oldPerms[p.name].multi)) / 30) * remainedDays
            }
        }
    }
    return { price: Math.ceil(price) }
}
